
// tslint:disable: typedef
export const availableProviders = [
    {
        name: "Cerebras",
        models: [
            { id: "gpt-oss-120b", name: "GPT OSS 120b" },
            { id: "llama3.1-8b", name: "Llama 3.1 8b" },
            //{ id: "llama-3.3-70b", name: "Llama 3.3 70b" },
            { id: "qwen-3-235b-a22b-instruct-2507", name: "Qwen 3 235b Instruct" },
            //{ id: "llama-4-scout-17b-16e-instruct", name: "Llama 4 Scout Instruct 17b" },
            { id: "zai-glm-47", name: "Z.ai GLM 4.7" }
        ]
    },
    {
        name: "Anthropic",
        models: [
            { id: "claude-sonnet-4-6", name: "Sonnet 4.6" },
            { id: "claude-opus-4-6", name: "Opus 4.6" },
            { id: "claude-haiku-4-5", name: "Haiku 4.5" }
        ]
    },
    {
        name: "Mistral",
        models: [
            { id: "mistral-large-latest", name: "Mistral large" },
            { id: "mistral-medium-latest", name: "Mistral medium" },
            // { id: "mistral-small-latest", name: "Mistral small" },
            // { id: "mistral-tiny-latest", name: "Mistral tiny" },
            { id: "ministral-8b-latest", name: "Ministral 8b" },
            { id: "codestral-latest", name: "Codestral" },
            { id: "devstral-latest", name: "Devstral" }
        ]
    },
    {
        name: "Google",
        models: [
            { id: "gemini-2.5-flash", name: "Gemini 2.5 Flash" },
            { id: "gemini-2.5-flash-lite", name: "Gemini 2.5 Flash-Lite" }
        ]
    },
    {
        name: "Scaleway",
        models: [
            { id: "gemma-3-27b-it", name: "Gemma 3 27b" }
        ]
    },
    {
        name: "OpenAI",
        models: [
            { id: "gpt-5-nano", name: "GPT-5 Nano" },
            { id: "gpt-4.1-nano", name: "GPT-4.1 Nano" }
        ]
    },
    {
        name: "xAI",
        models: [
            { id: "grok-4.3", name: "Grok 4.3" }
        ]
    }
];
